/* Webブラウザで表示する際の処理を記述する */
import wrapWithProvider from "./wrap-with-provider"

export const wrapRootElement = wrapWithProvider
